export default __webpack_public_path__ + "static/media/(30).1632f878.jpg";